<template>
    <div class="home">
        <div class="home-header">
            <Header class="headerComponents"></Header>
        </div>
        <div class="home-content">
            <div class="home-content-child">
                <safe class="home-safe"></safe>
                <safe-data class="home-data"></safe-data>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Head.vue'
import Safe from '@/components/SafeBar.vue'
import SafeData from '@/components/SafeData.vue'
import http from '../utils/httpClient'
export default {
    components: {
        Header, Safe, SafeData
    },
    name: 'Home',
    data () {
        return {
            passwordExpirationTime: null,
        }
    },
    methods: {
        getPeopleMessage () {
            http.post('/people/info')
            .then(res => {
                if (res.head.responseCode == '0') {
                    if (res && res.body != null) {
                        // this.$store.commit('saveCurrentUser',`${res.body.uid} (${res.body.name})`);
                        this.passwordExpirationTime = res.body.passwordExpirationTime;
                        this.$store.commit('saveCurrentUser',res.body);
                    }
                } else {
                    this.$message.error(res.head.responseMessage);
                }
            })
            .catch( err => {
                console.log(err);
                
            }) 
        },
        // getToken () {
        //     http.login('/x_auth_token')
        //     .then((res)=>{
        //         if (res.head.responseCode == '0') {
        //             this.getPeopleMessage();
        //         }
        //     })
        //     .catch((err) =>{
                
        //     })
        // }
    },
    computed: {
        changeResetSuccess () {
            return this.$store.state.resetSuccess;
        }
    },
    watch: {
        passwordExpirationTime: function(){
            var overdue;
            if (this.passwordExpirationTime != null) {
                if (new Date(this.passwordExpirationTime.replace(/-/g,"/")).getTime() - new Date().getTime() >= 0) {
                    overdue = false;
                } else {
                    overdue = true;
                }
            } else {
                overdue = false;
            }
            this.$store.commit('saveOverdue',overdue);
        },
        changeResetSuccess () {
            this.getPeopleMessage();
        }
    },
    mounted () {
        console.log('route---',this.$route,'path---',this.$route.path);
        // this.getPeopleMessage();
        // this.getToken();
        if (this.$route.path == '/resetpassword') {
            console.log('不用登陆！');
        } else {
            this.getPeopleMessage();
        }
    }
}
</script>

<style scoped>
    .home{
        display: flex; height: 100%; flex-direction: column; min-width: 1100px;
    }
    .home-header{
        height: 60px;
    }
    .home-content{
        flex: 1; overflow: hidden; background: #F9F9F9;
    }
    .home-content-child{
        display: flex; height: 100%; 
    }
    .home-safe{
        width: 180px; 
    }
    .home-data{
        flex: 1; overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue